var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.23em",
    height: "1em",
    viewBox: "0 0 36.525 29.665"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18759"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-twitter",
    d: "M32.771 7.394c.023.324.023.649.023.973 0 9.9-7.532 21.3-21.3 21.3A21.154 21.154 0 0 1 0 26.306a15.486 15.486 0 0 0 1.808.093 14.992 14.992 0 0 0 9.294-3.2 7.5 7.5 0 0 1-7-5.191 9.44 9.44 0 0 0 1.414.116 7.917 7.917 0 0 0 1.97-.255 7.487 7.487 0 0 1-6-7.347v-.092a7.539 7.539 0 0 0 3.384.95A7.5 7.5 0 0 1 2.549 1.368a21.278 21.278 0 0 0 15.435 7.833 8.451 8.451 0 0 1-.185-1.715 7.493 7.493 0 0 1 12.955-5.121A14.738 14.738 0 0 0 35.505.557a7.466 7.466 0 0 1-3.291 4.125 15.007 15.007 0 0 0 4.311-1.162 16.092 16.092 0 0 1-3.754 3.87Z",
    fill: "#fec968"
  }))));
};
export default SvgTwitter;